<template>
  <md-icon
    class="sort-icon"
    :md-src="'/static/images/icon-sort-arrow.svg'"
  />
</template>

<script>
export default {
  name: 'SortColumn'
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.sort-icon {
  cursor: pointer;
  padding: 5px 7px 7px 7px;
  position: fixed;
}

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    /* IE10+ */
    .sort-icon {
      position: relative !important;
      left: -0.3em;
    }
  }

  @supports (-ms-ime-align:auto) {
    /* Edge+ */
    .sort-icon {
      position: relative !important;
      left: -0.3em;
    }
  }

.icon-sort-arrow {
  fill: $arrowColorHighlighted
}
</style>
